module.exports = __webpack_public_path__ + "static/media/red_nebula_LF.ab5fa45a.png";